var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 37,
    viewBox: "0 0 54 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4770_13525)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.01 36.84C41.9272 36.84 54.02 34.485 54.02 31.58C54.02 28.675 41.9272 26.32 27.01 26.32C12.0928 26.32 0 28.675 0 31.58C0 34.485 12.0928 36.84 27.01 36.84Z",
    fill: "#9096AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09998 12.99L17.19 2H36.83L46.91 12.99V21.18H7.09998V12.99Z",
    stroke: "#9096AE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.97 31.58H10.04C8.41998 31.58 7.09998 30.26 7.09998 28.64V13.42C7.09998 13.18 7.28998 12.99 7.52998 12.99H17.14C17.32 12.99 17.48 13.1 17.55 13.27L19.1 17.55C19.16 17.72 19.32 17.83 19.51 17.83H33.83C34 17.83 34.16 17.73 34.23 17.57L36.11 13.24C36.18 13.08 36.33 12.98 36.51 12.98H46.49C46.73 12.98 46.92 13.17 46.92 13.41V28.63C46.92 30.25 45.6 31.57 43.98 31.57L43.97 31.58Z",
    fill: "#BCC1D7",
    stroke: "#9096AE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4770_13525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 37,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.81668e6c976603b9e5f19f1ff484e736.svg";
export { ForwardRef as ReactComponent };